/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListUserSessionConsentsResult,
  ListUserSessionConsentsResult$inboundSchema,
} from "../components/listusersessionconsentsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListUserSessionConsentsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListUserSessionConsentsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListUserSessionConsentsSecurity = {
  option1?: ListUserSessionConsentsSecurityOption1 | undefined;
  option2?: ListUserSessionConsentsSecurityOption2 | undefined;
};

export type ListUserSessionConsentsRequest = {
  /**
   * Filter by subject URN.
   */
  subjectUrn?: string | undefined;
  /**
   * Filter by user_session_client id.
   */
  userSessionClientId?: string | undefined;
  /**
   * Filter by user_session_issuer id (joins through user_session_clients).
   */
  userSessionIssuerId?: string | undefined;
  /**
   * Pagination cursor: id of the last item from the previous page.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListUserSessionConsentsResponse = {
  result: ListUserSessionConsentsResult;
};

/** @internal */
export type ListUserSessionConsentsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListUserSessionConsentsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListUserSessionConsentsSecurityOption1$Outbound,
    ListUserSessionConsentsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listUserSessionConsentsSecurityOption1ToJSON(
  listUserSessionConsentsSecurityOption1:
    ListUserSessionConsentsSecurityOption1,
): string {
  return JSON.stringify(
    ListUserSessionConsentsSecurityOption1$outboundSchema.parse(
      listUserSessionConsentsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListUserSessionConsentsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListUserSessionConsentsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListUserSessionConsentsSecurityOption2$Outbound,
    ListUserSessionConsentsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listUserSessionConsentsSecurityOption2ToJSON(
  listUserSessionConsentsSecurityOption2:
    ListUserSessionConsentsSecurityOption2,
): string {
  return JSON.stringify(
    ListUserSessionConsentsSecurityOption2$outboundSchema.parse(
      listUserSessionConsentsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListUserSessionConsentsSecurity$Outbound = {
  Option1?: ListUserSessionConsentsSecurityOption1$Outbound | undefined;
  Option2?: ListUserSessionConsentsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListUserSessionConsentsSecurity$outboundSchema: z.ZodMiniType<
  ListUserSessionConsentsSecurity$Outbound,
  ListUserSessionConsentsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListUserSessionConsentsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListUserSessionConsentsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listUserSessionConsentsSecurityToJSON(
  listUserSessionConsentsSecurity: ListUserSessionConsentsSecurity,
): string {
  return JSON.stringify(
    ListUserSessionConsentsSecurity$outboundSchema.parse(
      listUserSessionConsentsSecurity,
    ),
  );
}

/** @internal */
export type ListUserSessionConsentsRequest$Outbound = {
  subject_urn?: string | undefined;
  user_session_client_id?: string | undefined;
  user_session_issuer_id?: string | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListUserSessionConsentsRequest$outboundSchema: z.ZodMiniType<
  ListUserSessionConsentsRequest$Outbound,
  ListUserSessionConsentsRequest
> = z.pipe(
  z.object({
    subjectUrn: z.optional(z.string()),
    userSessionClientId: z.optional(z.string()),
    userSessionIssuerId: z.optional(z.string()),
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      subjectUrn: "subject_urn",
      userSessionClientId: "user_session_client_id",
      userSessionIssuerId: "user_session_issuer_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listUserSessionConsentsRequestToJSON(
  listUserSessionConsentsRequest: ListUserSessionConsentsRequest,
): string {
  return JSON.stringify(
    ListUserSessionConsentsRequest$outboundSchema.parse(
      listUserSessionConsentsRequest,
    ),
  );
}

/** @internal */
export const ListUserSessionConsentsResponse$inboundSchema: z.ZodMiniType<
  ListUserSessionConsentsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListUserSessionConsentsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listUserSessionConsentsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListUserSessionConsentsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUserSessionConsentsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserSessionConsentsResponse' from JSON`,
  );
}
